import { gql } from "apollo-angular";

export const ME = gql`
  fragment ME on MilitaryEstimator {
    hdrMil
    link {
      url
    }
  }
`;